import { Component, Inject, OnInit, Input } from "@angular/core";
import { RemitoFilter } from "../remitos-home.component";
import { DateAdapter, MdDialogRef } from "@angular/material";
import { remitosFiltersName, RemitosService } from "@services/remitos-service";
import * as moment from "moment";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { RemitoAcopio } from "../../common";
import { SEARCH_TYPE_CUENTA, SearchService } from "@services/search-service";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "app-remitos-filtros-dialog",
  templateUrl: "./remitos-filtros-dialog.component.html",
  styleUrls: [
    "./remitos-filtros-dialog.component.scss",
    "../../common/remitos-common-styles.scss",
  ],
})
export class RemitosFiltrosDialogComponent implements OnInit {
  public nombreFiltro: string = "";

  public filterNames = remitosFiltersName;

  public filter: RemitoFilter[] = [];

  acopioStateControl: FormControl;

  form: FormGroup;

  listaAcopios: RemitoAcopio[] = [];
  acopiosFiltered: RemitoAcopio[] = [];

  listaCentrosEmisores: any[] = [];
  centrosEmisoresFiltered: any[] = [];
  @Input() isAdmin: boolean = false;
  clientesSearched: Observable<any>;

  constructor(
    private dateAdapter: DateAdapter<Date>,
    private fb: FormBuilder,
    private dialogRef: MdDialogRef<RemitosFiltrosDialogComponent>,
    private remitosService: RemitosService,
    private searchService: SearchService
  ) {
    dateAdapter.setLocale("en-GB");
  }

  ngOnInit() {
    this.form = this.fb.group({
      fecha: [
        this.filter.find((x) => x.name === remitosFiltersName.fecha).value
          ? moment(
              this.filter.find((x) => x.name === remitosFiltersName.fecha).value
            ).toDate()
          : null,
      ],
      // numeroLegal: [this.filter.find(x => x.name === remitosFiltersName.numLegal).value],
      acopioSearch: [""],
      acopioSelected: [
        this.filter.find((x) => x.name === remitosFiltersName.acopio).value,
      ],
      clienteSearch: [""],
      clienteSelected: [
        this.filter.find((x) => x.name === remitosFiltersName.cliente).value,
      ],
      centroEmisorSearch: [""],
      centroEmisorSelected: [
        this.filter.find((x) => x.name === remitosFiltersName.centroEmisor)
          .value,
      ],
    });
    this.listaAcopios = this.remitosService.acopiosAll;
    // seteamos los autocomplete
    this.form
      .get("acopioSearch")
      .valueChanges.startWith(null)
      .debounceTime(100)
      .subscribe((res) => {
        if (res && res.toString().length > 1) {
          this.acopiosFiltered = this.listaAcopios.filter((x) =>
            x.Nombre.toLowerCase().includes(res.toString().toLowerCase())
          );
        } else {
          this.acopiosFiltered = [];
        }
      });

    this.clientesSearched = this.form
      .get("clienteSearch")
      .valueChanges.startWith(null)
      .debounceTime(1000)
      .switchMap((value) => {
        if (value && value.length > 2) {
          return this.searchService.searchAutocomplete(
            value,
            SEARCH_TYPE_CUENTA
          );
        } else {
          return Observable.from([]);
        }
      })
      .map((value) => {
        value.forEach((emp) => {
          if (emp.CuentaAcopio) {
            emp.cuentasAcopios = "";
            emp.CuentaAcopio.forEach((e) => {
              if (e.CuentaAcopio !== 0) {
                emp.cuentasAcopios += e.CuentaAcopio.toString() + ", ";
              }
            });
            if (emp.cuentasAcopios.length) {
              emp.cuentasAcopios = emp.cuentasAcopios.slice(0, -2);
            }
          }
        });
        return value;
      });

    // auto-complete de centro emisor
    let currentAcopio = this.filter.find(
      (x) => x.name === remitosFiltersName.acopio
    );
    if (currentAcopio.value) {
      let IdAcopio = currentAcopio.value.IdAcopio;
      this.remitosService.getCentrosEmisores(IdAcopio).subscribe((data) => {
        this.listaCentrosEmisores = data;
        this.form
          .get("centroEmisorSearch")
          .valueChanges.startWith(null)
          .debounceTime(100)
          .subscribe((res) => {
            if (res && res.toString().length > 0) {
              this.centrosEmisoresFiltered = this.listaCentrosEmisores.filter(
                (x) => x.CentroEmisorId.toString().includes(res.toString())
              );
            } else {
              this.centrosEmisoresFiltered = [];
            }
          });
      });
    }
  }

  onSubmit() {
    this.filter.forEach((fil) => {
      switch (fil.name) {
        case remitosFiltersName.fecha:
          fil.value = this.form.get("fecha").value
            ? this.form.get("fecha").value
            : null;
          break;
        // case remitosFiltersName.numLegal:
        //   fil.value = this.form.get('numeroLegal').value ? this.form.get('numeroLegal').value : null;
        //   break;
        case remitosFiltersName.acopio:
          fil.value = this.form.get("acopioSelected").value
            ? this.form.get("acopioSelected").value
            : null;
          break;
        case remitosFiltersName.cliente:
          fil.value = this.form.get("clienteSelected").value
            ? this.form.get("clienteSelected").value
            : null;
          break;
        case remitosFiltersName.centroEmisor:
          fil.value = this.form.get("centroEmisorSelected").value
            ? this.form.get("centroEmisorSelected").value
            : null;
          break;
      }
    });

    this.dialogRef.close(this.filter);
  }

  selectAcopio(acopio: RemitoAcopio) {
    this.form.get("acopioSelected").setValue(acopio);
    this.form.get("acopioSearch").setValue("");
  }

  getAcopioSelected() {
    return this.form.get("acopioSelected").value;
  }

  deselectAcopio() {
    this.form.get("acopioSelected").setValue(null);
  }

  selectCentroEmisor(centroEmisor: any) {
    this.form.get("centroEmisorSelected").setValue(centroEmisor);
    this.form.get("centroEmisorSearch").setValue("");
  }

  getCentroEmisorSelected() {
    return this.form.get("centroEmisorSelected").value;
  }

  deselectCentroEmisor() {
    this.form.get("centroEmisorSelected").setValue(null);
  }

  selectedCliente(cuenta) {
    this.form
      .get("clienteSelected")
      .setValue({ Nombre: cuenta.FullName, Id: cuenta.An8 });
    this.form.get("clienteSearch").setValue("");
  }

  getClienteSelected() {
    return this.form.get("clienteSelected").value;
  }

  deselectCliente() {
    this.form.get("clienteSelected").setValue(null);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-home/remitos-filtros-dialog/remitos-filtros-dialog.component.ts